export default __webpack_public_path__ + "static/media/efficient-teamwork.73025227.svg";